module.exports = __webpack_public_path__ + "img/蠡县皮毛.c59e01f3.jpg";